<template>
  <div>
    <div v-if="info" :class="['pcp-gift-box', styleName]">
      <div class="pcp-gift-box-header">
        <img class="icon" :src="`${imgUrl}icons/iconPcpGiftPC.png`" alt="" />
        <div class="header-title">赠船上活动</div>
      </div>
      <div class="pcp-gift-box-content">
        <div class="banner-box" @click="handleOpen">
          <img class="pic" :src="info.thumbnailBanner" alt="" />
          <div class="linkBtn">查看详情></div>
        </div>
        <div class="name">{{info.name}} x{{guestNumber}}</div>
        <div class="price-box">
          <div class="price">{{price}}元</div>
          <div class="selling-price">{{info.sellingPrice}}美元</div>
        </div>
      </div>
      <div class="pcp-gift-box-desc">
        *赠送活动将在您完成订单支付后，最晚于开航前3天为您完成预订，并以短信通知。您可前往<span v-if="pageName==='BookingDetail'" class="link" @click="jumpPcpPage">皇家行前订</span><span v-else>皇家行前订</span>查看{{pageName==='BookingDetail' ? '订单详情':'预订详情'}}。
      </div>
    </div>

<!--    <div v-if="!isOnPagePopup && showModal" class="room-theme-popup">-->
<!--      <div class="room-theme-popup-inner">-->
<!--        <img @click="handleClose" class="room-theme-popup-close" :src="`${imgUrl}/index/couponPopupClose.png`" alt="" />-->
<!--        <img class="room-theme-popup-pic" :src="giftInfo?.roomPopupImgUrlWX" alt="" />-->
<!--      </div>-->
<!--    </div>-->

    <div class="popup popup-qiaohu" :class="{ 'modal-in': !isOnPagePopup && showModal, 'modal-out': !(!isOnPagePopup && showModal)}">
      <div class="js-smartScroll" style="position: relative;height: 100%;">
        <div @click="handleClose" class="promo-popup-close qiaohu_tag_cancel" style="position: absolute; right: 10px;top: 10px;width: 30px;z-index: 1;">
          <img src="https://resource.rcclchina.com.cn/cruiseSearch/popup/popup_close.png" style="width: 100%;">
        </div>
        <div class="promo-popup-content js-smartScroll" style="height: 100%;overflow: scroll;top: 0;">
          <img style="width: 100%;margin: auto;display: block;" :src="giftInfo?.roomPopupImgUrlWX">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiPcp from "@/api/PCP/index";
import {formatDateComplete} from "@/utilities/tools";
import api from "@/api";

export default {
  props: {
    guestNumber: {
      type: Number,
      default: 0
    },
    giftInfo: {
      type: Object,
      default: null
    },
    shipCode: {
      type: String,
      default: ""
    },
    sailDate: {
      type: String,
      default: ""
    },
    isOnPagePopup: {
      type: Boolean,
      default: false
    },
    allowPopup: {
      type: Boolean,
      default: true
    },
    pageName: {
      type: String,
      default: ""
    },
    stateroomIndex: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL + '/routesDetail/roomTheme/',
      info: null,
      showModal: false,
      price: 0,
      styleName: ""
    }
  },
  watch: {
    shipCode: {
      handler(val) {
        if (val) {
          this.getProductBriefInfo()
        }
      },
      immediate: true
    },
    pageName: {
      handler(val) {
        const StyleName = {
          'GuestInfo': 'isGuestInfo',
          'BookingDetail': 'isOrderDetail',
          'Pay': "isSettlement"
        }
        this.styleName = StyleName[val]
      },
      immediate: true
    },
    pageRefresh: {
      handler(val) {
        if (val) {
          this.getProductBriefInfo()
        }
      }
    }
  },
  computed: {
    order() {
      return this.$store.state.booking.order;
    },
    pageRefresh() {
      return this.$store.state.page.pageRefresh
    }
  },
  methods: {
    async getProductBriefInfo() {
      const { giftInfo, shipCode, sailDate } = this
      const { errCode, data, errMsg } = await apiPcp.product.getProductBriefInfo({
        productId: giftInfo?.productId,
        shipCode: shipCode,
        sailDate: formatDateComplete(sailDate, false, '-'),
      })

      if (errCode === 0) {
        this.info = data
        this.$emit('getPcpGift', {
          ...data,
          price: this.price
        })
        if(this.pageName === 'GuestInfo') {
          let order = {...this.order};
          // console.log('order.bookings', order.bookings[this.stateroomIndex])
          order.bookings[this.stateroomIndex]['pcpGiftInfo'] = {
            ...data,
            price: this.price
          };
          // console.log('this.order', order)
          this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
          // 刷新页面
          this.$store.commit("SET_PAGE_REFRESH", "");
        }
      } else {
        console.log(errMsg)
      }
    },
    handleOpen() {
      if (!this.allowPopup) return
      if (this.isOnPagePopup) {
        this.onPageOpen()
      } else {
        this.open()
      }
    },
    onPageOpen() {
      // const { groupType, imgUrl } = this
      // let groupTypePic = ''
      // if (groupType === 'QIAOHU') {
      //   groupTypePic = `${imgUrl}/qiaoHu/popup.png`
      // } else if (groupType === 'STARRYSKY') {
      //   groupTypePic = `${imgUrl}/starrySky/popup.png`
      // } else if (groupType === 'CUSTOM' || groupType === 'PCPGIFT') {
      //   groupTypePic = this.roomImages.roomPopupImgUrlWX
      // }
      this.$emit('open', { ...this.giftInfo })
    },
    open() {
      this.showModal = true
    },
    handleClose() {
      this.showModal = false
    },
    async jumpPcpPage() {
      const {data} = await api.user.getPcpToken();
      let token = "";
      if (data && data.length > 0) {
        token = data;
      }
      window.location.href = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`;
    }
  }
}
</script>

<style scoped lang="less">
.pcp-gift-box {
  margin-top: 10px;
  border-top: 1px solid #EEEEEE;
  &.isSettlement {
    border-top: none;
    margin-right: 219px;
    & .pcp-gift-box-header {
      padding: 10px 0 10px;
      & .header-title {
        font-size: 16px;
      }
    }
    & .pcp-gift-box-content {
      padding: 0 0;
      & .name {
        font-size: 14px;
      }
    }
    & .pcp-gift-box-desc {
      padding: 15px 0 18px 0;
      font-size: 12px;
    }
    & .price-box {
      align-items: flex-end;
      & .price {
        font-size: 14px;
        color: #ff3022;
      }
      & .selling-price {
        font-size: 12px;
      }
    }
  }

  &.isOrderDetail {
    border: 1px solid #ecedee;
    border-top: 2px solid #e6f4ff;
    margin-top: 0;
    & .pcp-gift-box-header {
      padding: 15px 22px 15px;
      & .header-title {
        font-size: 16px;
      }
    }
    & .pcp-gift-box-content {
      padding: 0 22px 0 22px;
      & .name {
        font-size: 14px;
      }
    }
    & .pcp-gift-box-desc {
      padding: 15px 22px 15px 22px;
      font-size: 12px;
    }
    & .price-box {
      align-items: flex-end;
      flex-direction: column;
      & .price {
        font-size: 14px;
        color: #444444;
      }
      & .selling-price {
        font-size: 12px;
      }
    }
  }

  &.isGuestInfo {
    width: 704px;
    margin-left: 23px;
    margin-top: 17px;
    border: none;
    & .pcp-gift-box-header {
      padding: 10px 0 10px;
      & .header-title {
        font-size: 16px;
      }
    }
    & .pcp-gift-box-content {
      padding: 0 0;
      & .name {
        font-size: 14px;
      }
    }
    & .pcp-gift-box-desc {
      padding: 15px 0 13px 0;
      font-size: 12px;
    }
    & .price-box {
      align-items: flex-end;
      & .price {
        font-size: 14px;
        color: #ff3022;
      }
      & .selling-price {
        font-size: 12px;
      }
    }
  }
}
.pcp-gift-box-header {
  display: flex;
  align-items: center;
  gap: 0 7px;
  padding: 13px 14px;
  & .icon {
    display: block;
    height: 20px;
    width: 20px;
  }
  & .header-title {
    height: 17px;
    font-weight: 500;
    font-size: 18px;
    line-height: 17px;
    color: #282b2c;
  }
}
.pcp-gift-box-content {
  display: flex;
  align-items: center;
  gap: 0 11px;
  padding: 0 18px 0 22px;
  & .name {
    font-size: 12px;
    font-weight: 500;
    width: calc(100% - 140px - 90px - 22px);
  }
}
.banner-box {
  position: relative;
  width: 90px;
  height: 52px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  & .pic{
    display: block;
    width: 100%;
    height: 100%;
    /* border: 2px solid #979797; */
  }
  & .linkBtn {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 14px;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    border-radius: 0 0 3px 3px;
    background: #00000050;
    color: #FFFFFF;
  }
}
.price-box {
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0 10px;
  & .price {
    height: 17px;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: #F33D0F;
  }
  & .selling-price {
    font-size: 10px;
    height: 17px;
    line-height: 17px;
    text-decoration-line: line-through;
    color: #919b9f;
  }
}
.pcp-gift-box-desc {
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  padding: 10px 12px 0 22px;
  color: #919b9f;
  & .link {
    cursor: pointer;
    text-decoration: underline;
    color: #006ab9;
  }
}
.room-theme-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}
.room-theme-popup-inner {
  position: relative;
  width: 650px;
  height: 1036px;
}
.room-theme-popup-pic {
  display: block;
  width: 650px !important;
  height: 1036px !important;
}
.room-theme-popup-close {
  position: absolute;
  right: -35px;
  top: -35px;
  z-index: 10;
  display: block;
  height: 70px !important;
  width: 70px !important;
}
.popup {
  position: fixed;
  display: block;
  opacity: 0;
}
.popup.modal-in{
  opacity: 100;
}
</style>